module.exports = __webpack_public_path__ + "static/p5-2a3ba70df072a03c44404711c7cdf0a7.jpg";